import React from 'react'
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';
import HeroBannerContent from './heroBannerContent'

const HeroBannerComponent = React.memo(({
	fromGradPackages,
	pageContentData = {},
	scrollPosition,
	isDegreeSelected,
	heading,
	firstPackageName,
	hsPaymentPromo,
	packageGroupData,
	popularPackage,
	altImage,
	hsRepAnnouncement,
	repMessage,
}) => {
	
	return !!Object.keys(pageContentData).length && (
		<>
			<div className="product-categories">
				<div className="row mb-3 mx-2">
					<div className="container-fluid school-banner">
						<div className="img-wrapper group-name">
							<picture>
								<source media="(min-width: 1024px)" srcSet={pageContentData.imageUrl?.xl} />
								<LazyLoadImage src={pageContentData.imageUrl?.md} alt={pageContentData?.imgAltText} scrollPosition={scrollPosition} />
							</picture>
						</div>
						<HeroBannerContent
							isDegreeSelected={isDegreeSelected}
							hsPaymentPromo={hsPaymentPromo}
							heading={heading}
							pageContentDataHeading={pageContentData.heading}
							firstPackageName={firstPackageName}
							packageGroupProducts={packageGroupData?.products}
							fromGradPackages={fromGradPackages}
							popularPackage={popularPackage}
							altImage={altImage}
							hsRepAnnouncement={hsRepAnnouncement}
							repMessage={repMessage}
						/>
					</div>
				</div>
			</div>
		</>
	)
})

export default trackWindowScroll(HeroBannerComponent)